import { createRouter, createWebHistory } from 'vue-router'
import StepOne from './components/StepOne.vue'


export default createRouter({
    history: createWebHistory(),
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'step-one',
            component: StepOne
        },

    ]
})
